import axios from "axios";

const RELEASE_COOKIE_NAME = "mysite_react_19";
const FEATURE_KEYS = ["UniversalLogin"];

// Scope to the parent .vagaro.com domain so this cookie is visible the same way
// Imperva's own incap_ses_*/visid_incap_*/nlbi_* cookies are (shared across every
// *.vagaro.com host, not just the one that set it). Omitted outside vagaro.com (e.g.
// localhost, bookitall.com test hosts) since browsers silently reject a domain
// attribute that doesn't match the current host.
function releaseCookieDomainAttr() {
  const host = window.location.hostname;
  return host === "vagaro.com" || host.endsWith(".vagaro.com") ? "; domain=.vagaro.com" : "";
}

function expireLegacyHostOnlyCookie() {
  document.cookie = `${RELEASE_COOKIE_NAME}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
}

// A host-only cookie (no domain attribute - e.g. one set before this domain scoping
// existed, or added manually via DevTools) is a distinct identity from a .vagaro.com-scoped
// one, even with the same name/path. Both set and clear expire the legacy variant first so
// it can never linger with a stale value alongside the current one.
function setReleaseCookie() {
  const domainAttr = releaseCookieDomainAttr();
  if (domainAttr) {
    expireLegacyHostOnlyCookie();
  }
  document.cookie = `${RELEASE_COOKIE_NAME}=true; path=/${domainAttr}`;
}

function clearReleaseCookie() {
  expireLegacyHostOnlyCookie();
  const domainAttr = releaseCookieDomainAttr();
  if (domainAttr) {
    document.cookie = `${RELEASE_COOKIE_NAME}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT${domainAttr}`;
  }
}

// merchantid isn't always known this early in bootstrap (e.g. in the Editor it only
// resolves once the style/layout route loads, and vwbencmerchantID is only injected
// server-side on live rendered business pages - see ServerRenderingController), so it's
// sent when available and omitted otherwise, matching the optional-header convention
// used by the rest of the API wrappers in this app.
export async function resolveReleaseFlags(apiUrl, overrides = {}) {
  const group = (overrides.group || localStorage.getItem("Group") || "US02").toUpperCase();
  const merchantid = overrides.merchantid || document.getElementById("vwbencmerchantID")?.value || "";

  const headers = {
    "Content-Type": "application/json",
    device: "Website",
    grouptoken: group,
    ...(merchantid && { merchantid }),
  };

  try {
    const response = await axios.post(
      `${apiUrl}/${group}/api/v3/merchants/business/release-manager/flags/resolve`,
      { platform: "web", featureKeys: FEATURE_KEYS, ...(merchantid && { merchantId: merchantid }) },
      { headers }
    );
    const flags = response?.data?.data ?? [];
    const resolved = flags.find((flag) => flag?.featureKey === FEATURE_KEYS[0]);
    if (resolved?.enabled === true) {
      setReleaseCookie();
    } else {
      clearReleaseCookie();
    }
  } catch {
    // Flag service unreachable/unresolved - leave any existing release cookie untouched.
  }
}
